var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.loading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      _c("div", [
        _c("h1", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.$t("customer.scan_users.scan_users")) + " "),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c(
              "a",
              {
                staticClass: "button is-link is-outlined",
                on: {
                  click: function ($event) {
                    return _vm.addUser()
                  },
                },
              },
              [
                _c("b-icon", { attrs: { icon: "plus" } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("global.add")) + " ")]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-table",
                {
                  attrs: {
                    loading: _vm.loading,
                    narrowed: true,
                    striped: true,
                    paginated: true,
                    data: _vm.users,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function (props) {
                        return [
                          !!props.column.meta
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    active: !!props.column.meta,
                                    label: props.column.meta,
                                    dashed: "",
                                  },
                                },
                                [[_vm._v(_vm._s(props.column.label))]],
                                2
                              )
                            : _c("span", [_vm._v(_vm._s(props.column.label))]),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "name",
                                label: _vm.$t("global.name"),
                                sortable: "",
                              },
                            },
                            [[_vm._v(_vm._s(props.row.name))]],
                            2
                          ),
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "code",
                                label: _vm.$t("customer.scan_users.code"),
                                sortable: "",
                              },
                            },
                            [[_vm._v(_vm._s(props.row.code))]],
                            2
                          ),
                          _c(
                            "b-table-column",
                            { attrs: { label: _vm.$t("global.actions") } },
                            [
                              _c("span", { staticClass: "field is-grouped" }, [
                                _c("p", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-small is-info is-outlined",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showEditForm(props.row)
                                        },
                                      },
                                    },
                                    [[_vm._v(_vm._s(_vm.$t("global.edit")))]],
                                    2
                                  ),
                                ]),
                                _c("p", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-small is-danger is-outlined",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteUser(props.row)
                                        },
                                      },
                                    },
                                    [[_vm._v(_vm._s(_vm.$t("global.delete")))]],
                                    2
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("template", { slot: "empty" }, [_c("nothing-here")], 1)],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-table",
                {
                  attrs: {
                    loading: _vm.loading,
                    narrowed: true,
                    striped: true,
                    paginated: true,
                    data: _vm.filteredDevices,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function (props) {
                        return [
                          !!props.column.meta
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    active: !!props.column.meta,
                                    label: props.column.meta,
                                    dashed: "",
                                  },
                                },
                                [[_vm._v(_vm._s(props.column.label))]],
                                2
                              )
                            : _c("span", [_vm._v(_vm._s(props.column.label))]),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "uuid",
                                label: "Uuid",
                                sortable: "",
                              },
                            },
                            [[_vm._v(_vm._s(props.row.uuid))]],
                            2
                          ),
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "serial",
                                label: _vm.$t(
                                  "customer.scan_users.serial_number"
                                ),
                                sortable: "",
                              },
                            },
                            [[_vm._v(_vm._s(props.row.serialNumber))]],
                            2
                          ),
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "lastSyncAt",
                                label: _vm.$t(
                                  "customer.scan_users.last_sync_at"
                                ),
                                sortable: "",
                              },
                            },
                            [
                              _c("span", { staticClass: "tag is-primary" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      new Date(
                                        props.row.lastSyncAt
                                      ).toLocaleString()
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customer.scan_users.auth_activated"
                                ),
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field is-grouped" },
                                [
                                  _c("b-switch", {
                                    attrs: {
                                      type: "is-info",
                                      "true-value": 1,
                                      "false-value": 0,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.switchChange(props.row)
                                      },
                                    },
                                    model: {
                                      value: props.row.authActivated,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "authActivated",
                                          $$v
                                        )
                                      },
                                      expression: "props.row.authActivated",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "b-table-column",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customer.scan_users.auth_required"
                                ),
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field is-grouped" },
                                [
                                  _c("b-switch", {
                                    attrs: {
                                      type: "is-info",
                                      "true-value": 1,
                                      "false-value": 0,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.switchChange(props.row)
                                      },
                                    },
                                    model: {
                                      value: props.row.authRequired,
                                      callback: function ($$v) {
                                        _vm.$set(props.row, "authRequired", $$v)
                                      },
                                      expression: "props.row.authRequired",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("template", { slot: "empty" }, [_c("nothing-here")], 1)],
                2
              ),
              _c(
                "span",
                [
                  _c("b-icon", {
                    attrs: { icon: "exclamation-circle", type: "is-warning" },
                  }),
                  _c("i", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("customer.scan_users.warning_message1"))
                    ),
                  ]),
                  _c("br"),
                  _c("i", [
                    _vm._v(
                      _vm._s(_vm.$t("customer.scan_users.warning_message2"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditing,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditing = $event
            },
          },
        },
        [
          _c("userForm", {
            attrs: { user: _vm.userToEdit, "is-submitting": _vm.isSubmitting },
            on: {
              submitUpdate: _vm.submitUpdateUser,
              submitCreate: _vm.submitCreateUser,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }